import { render, staticRenderFns } from "./WalletOption.vue?vue&type=template&id=ac5a28a8&scoped=true&"
import script from "./WalletOption.vue?vue&type=script&lang=js&"
export * from "./WalletOption.vue?vue&type=script&lang=js&"
import style0 from "./WalletOption.vue?vue&type=style&index=0&id=ac5a28a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5a28a8",
  null
  
)

export default component.exports